import React from "react"


// #00479C
function NewsPost (props){

  const newsStyle ={
    borderRadius: '3%',
    WebkitBoxShadow: '4px 9px 12px 4px rgba(51,74,230,0.53)',
    MozBoxShadow: '4px 9px 12px 4px rgba(51,74,230,0.53)',
    boxShadow: '4px 9px 12px 4px rgba(51,74,230,0.53)',
  
  
}

  
  return(
    <div className="card text-dark my-4" style={newsStyle}>
      <div className="card-header ">
        Category:  Publication / Paper 
      </div>
      <div className="card-body">
        <h6 className="card-title">Liver extracellular matrix providing dual functions of two dimensional substrate coating and three-dimensional injectable hydrogel platform for liver tissue engineering</h6>
        <p className="card-text">저자명 : Jung Seung Lee, Jisoo Shon, Hae-Min Park, Yun-Gon Kim, Byung-Gee Kim, Jong-Won Oh, and Seung-Woo Cho
        Biomacromolecules 2014, 15(1) 206-218
        </p>
        <a href="" className="btn btn-primary">More</a>
      </div>
      <div className="card-footer">
        2 weeks ago
      </div>
    </div>
  )
}

export default NewsPost